export const FILTER_FIELDS = [
  'from',
  'to',
  'ebitdaFrom',
  'ebitdaTo',
  'industry',
  'location',
  'listingType',
];

export const LIMIT = '25';
